export default __webpack_public_path__ + "80865a7f65d47863b3b264a9ed09629a.png";